export type MileageOption = {
  name: string;
  value: string;
};

export const getMilesPerYearOptions = (values: string[] = []): MileageOption[] => {
  const options: MileageOption[] = [
    {
      name: 'Low Gear Plan (~5,000 mi)',
      value: '0',
    },
    {
      name: 'Standard Plan (~10,000 mi)',
      value: '850',
    },
    {
      name: 'Cruiser Plan (~15,000 mi)',
      value: '1200',
    },
    {
      name: 'Road Warrior Plan (~24,000 mi)',
      value: '2000',
    },
  ];

  return values.length > 0
    ? options.filter((option) => values.includes(option.value))
    : options;
};
